import React, { forwardRef } from "react";
import TickIcon from "../../../assets/images/tick1.svg";
import { CircularLoader } from "../../../components";

const fixLinksInHtml = (html) => {
  return html.replace(/href="(?!https?:\/\/)([^"]+)"/g, 'href="https://$1"');
};

const AnnouncementModalItem = forwardRef(({ subject, message, createdAt, activeAnnouncementId, id, isRead, isLoading, markAsRead }, ref) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthName = months[date.getMonth()];
    const day = date.getDate();
    const getOrdinalSuffix = (num) =>
      num % 10 === 1 && num !== 11
        ? "st"
        : num % 10 === 2 && num !== 12
        ? "nd"
        : num % 10 === 3 && num !== 13
        ? "rd"
        : "th";

    return `${monthName} ${day}${getOrdinalSuffix(day)}`;
  };

  const sanitizedMessage = fixLinksInHtml(message);

  return (
    <div className="rounded-[12px] mb-2">
      <div className="text-xs md:text-sm py-2 text-[#6B7280]">{formatDate(createdAt)}</div>
      <div
        ref={ref}
        className={`px-4 py-2 rounded-lg relative ${
          activeAnnouncementId === id ? "bg-[#F8FAFC] border border-solid border-[#E5E7EB]" : ""
        }`}>
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="text-sm md:text-base font-bold text-[#1F2937]">{subject}</div>
            <div className="text-xs md:text-sm py-2 text-[#1F2937]" dangerouslySetInnerHTML={{ __html: sanitizedMessage }}></div>
          </div>
          {!isRead && (
            <div className="ml-4 flex-shrink-0">
              {isLoading ? (
                <div className="flex items-center gap-2 text-[#6B7280] text-sm">
                  <span>Marking as read...</span>
                  <CircularLoader className="w-4 h-4" />
                </div>
              ) : (
                <button
                  onClick={() => markAsRead(id)}
                  className="
                    flex items-center gap-2
                    bg-transparent border border-teal text-teal
                    hover:bg-teal hover:bg-opacity-10
                    text-center py-1 px-2 rounded-md
                    transition-all duration-200 text-sm
                  "
                >
                  <span>Mark as read</span>
                  <img className="w-4 h-4" src={TickIcon} alt="Mark as read" />
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default AnnouncementModalItem;
